import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ component: Component }) => {
  const { keycloak, initialized } = useKeycloak();

  if (!initialized) return <div>Carregando...</div>; // Aguarda a inicialização do Keycloak

  return keycloak.authenticated ? <Component /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
